







import { Component, Prop, Vue } from "vue-property-decorator";
import * as Enumerable from "linq-es5";

import * as def from "@/definitions";

const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;
@Component({
  components: {}
})
export default class Knob extends Vue {
  @Prop()
  gradientColor!: {
    id: number;
    color: string;
    position: number;
    isSelected: boolean;
    isRangeVisible: boolean;
  };

  get knobStyle() {
    //即席の処理
    if (this.gradientColor.isSelected) {
      //選択中
      if (this.gradientColor.position > 50) {
        //50より大きかったら
        return {
          width: "8%",
          background: "transparent",
          left: this.gradientColor.position - 8 + "%",
          border: "solid 1px #ffffff",
          height: "calc(100% - 2px)"
        };
      } else {
        //50より小さかったら
        return {
          width: "8%",
          background: "transparent",
          left: this.gradientColor.position + "%",
          border: "solid 1px #ffffff",
          height: "calc(100% - 2px)"
        };
      }
    } else {
      //選択されてない
      if (this.gradientColor.position > 50) {
        //50より大きかったら
        return {
          width: "4%",
          background: "#ffffff",
          left: this.gradientColor.position - 4 + "%"
        };
      } else {
        //50より小さかったら
        return {
          width: "4%",
          background: "#ffffff",
          left: this.gradientColor.position + "%"
        };
      }
    }
  }

  selectGradientColor(event: MouseEvent) {
    this.$emit("selectGradientColor", this.gradientColor.id, event.clientX);
  }
}
